import {
  GET_CLIENTS,
  CLEAR_WAIVERS,
  PENDING_CLIENTS,
  GET_CLIENT_BY_CIF,
  CLEAR_CLIENT_LIST,
  GET_CLIENT_WAIVERS,
  GET_CLIENT_MODULES,
  CLEAR_CLIENT_BY_CIF,
  GET_CLIENT_ACCOUNTS,
  CLEAR_PENDING_CLIENTS,
  CLEAR_CLIENT_ACCOUNTS,
  GET_INSTITUTIONS_PROFILE,
} from "../constants/constants";

const initialSessionState = {
  clients: [],
  client: {},
  account: [],
  modulo: [],
  pending: [],
  institution: {},
  waivers: [],
};

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case GET_CLIENT_BY_CIF:
      return {
        ...state,
        client: { ...action.client },
      };
    case GET_CLIENT_ACCOUNTS:
      return {
        ...state,
        account: [...action.account.accounts],
      };
    case GET_CLIENT_MODULES:
      return {
        ...state,
        modulo: [...action.modulo],
      };
    case GET_INSTITUTIONS_PROFILE:
      return {
        ...state,
        institution: { ...action.institution },
      };
    case GET_CLIENTS:
      return {
        ...state,
        clients: [...action.clients.content],
        totalElements: action.clients.totalElements,
      };
    case PENDING_CLIENTS:
      return {
        ...state,
        pending: [...action.pending.content],
        pendingElements: action.pending.totalElements,
      };
    case CLEAR_CLIENT_LIST:
      return {
        ...state,
        clients: {},
        totalElements: 0,
      };
    case CLEAR_PENDING_CLIENTS:
      return {
        ...state,
        pending: [],
        pendingElements: 0,
      };
    case CLEAR_CLIENT_BY_CIF:
      return {
        ...state,
        client: {},
      };
    case CLEAR_CLIENT_ACCOUNTS:
      return {
        ...state,
        account: [],
      };
    case GET_CLIENT_WAIVERS:
      return {
        ...state,
        waivers: [...action.waivers],
      };
    case CLEAR_WAIVERS:
      return {
        ...state,
        waivers: [],
      };
    default:
      return state;
  }
};

export const getClient = (state) => state.clientReducer.client;
export const getModules = (state) => state?.clientReducer?.modulo;
export const getWaivers = (state) => state.clientReducer.waivers;
export const getAccounts = (state) => state.clientReducer.account;
export const getClientList = (state) => state.clientReducer.clients;
export const getPendingClients = (state) => state.clientReducer.pending;
export const getTotalElements = (state) => state.clientReducer.totalElements;
export const getInstitutionsProfile = (state) =>
  state.clientReducer.institution;
export const getTotalPendingClients = (state) =>
  state.clientReducer.pendingElements;
